import React from 'react';
import { StyledFullmap, StyledFullmapWrap, StyledFullmapCover, StyledFullmapMap } from './styles';
export function FullmapCover(props) {
  return /*#__PURE__*/React.createElement(StyledFullmapCover, Object.assign({
    className: props.className,
    style: props.style
  }, process.env.ENV_RAW ? null : props.uiEvents), /*#__PURE__*/React.createElement(StyledFullmapMap, {
    className: "has-iframe",
    id: "full-map--googleid"
  }, /*#__PURE__*/React.createElement("iframe", {
    title: "Google Maps",
    width: "100%",
    height: "100%",
    frameBorder: "0",
    src: "https://www.google.com/maps/embed/v1/place?key=" + process.env.GOOGLE_MAPS_API_KEY + "&q=" + encodeURIComponent(props.place) + "&zoom=" + (props.zoom || 10),
    allowFullScreen: true
  }), props.children));
}
export function FullmapWrap(props) {
  return /*#__PURE__*/React.createElement(StyledFullmapWrap, Object.assign({
    className: props.className,
    style: props.style
  }, process.env.ENV_RAW ? null : props.uiEvents), props.children);
}
export function Fullmap(props) {
  return /*#__PURE__*/React.createElement(StyledFullmap, Object.assign({
    id: props.name,
    className: props.className,
    style: props.style
  }, process.env.ENV_RAW ? null : props.uiEvents), props.children);
}